<div class="register-section">
    <div class="separator"></div>
    <p class="heading">{{ "landing.register" | cxTranslate }}</p>
    <p class="description">
        <span>{{ "landing.keyfeature" | cxTranslate }}</span>
    </p>
    <div class="services-holder row mt-5 mb-5">
        <!-- <div class="service">
            <div class="service-bubble">
                <div class='category-icon'><span></span></div>
            </div>
            <div class="service-desc">
                <p class="header">BROWSE</p>
                <p class="desc">Product Catalog</p>
            </div>
        </div> -->
        <!-- <div class="service">
            <div class="service-bubble">
                <i class='material-icons'>attach_money</i>
            </div>
            <div class="service-desc">
                <p class="header">VIEW</p>
                <p class="desc">Product Price</p>
            </div>
        </div> -->
        <!-- <div class="service">
            <div class="service-bubble">
                <i class='material-icons'>receipt</i>
            </div>
            <div class="service-desc">
                <p class="header">{{ "landing.request" | cxTranslate }}</p>
                <p class="desc">{{ "landing.quotes" | cxTranslate }}</p>
            </div>
        </div> -->
        <!-- <div class="service">
            <div class="service-bubble">
                <i class='material-icons'>notifications</i>
            </div>
            <div class="service-desc">
                <p class="header">RECEIVE</p>
                <p class="desc">Notifications</p>
            </div>
        </div> -->
        <div class="service">
            <div class="service-bubble">
                <i class='material-icons'>assignment_turned_in</i>
            </div>
            <div class="service-desc">
                <p class="header">{{ "landing.track" | cxTranslate }}</p>
                <p class="desc">{{ "landing.orderstatus" | cxTranslate }} </p>
            </div>
        </div>
        <div class="service">
            <div class="service-bubble">
                <i class='material-icons'>shopping_cart</i>
            </div>
            <div class="service-desc">
                <p class="header">{{ "landing.place" | cxTranslate }}</p>
                <p class="desc">{{ "landing.orders" | cxTranslate }}</p>
            </div>
        </div>
        <div class="service mr-0">
            <div class="service-bubble">
                <i class='material-icons'>store</i>
            </div>
            <div class="service-desc">
                <p class="header">{{ "landing.check" | cxTranslate }}</p>
                <p class="desc">{{ "landing.productavailble" | cxTranslate }}</p>
            </div>
        </div>
    </div>
    <div class="register-actions">
        <!-- Hidden until OKTA implementation -->
        <button class="vs-primary-btn" (click)="onRegisterClick()">
            <span>{{ "landing.registorBtn" | cxTranslate }}</span>
        </button>
        <div class="description mt-2">
            <span>{{ "landing.haveaccount" | cxTranslate }} </span>
            <a routerLink="/login" class="login-link">{{ "landing.login" | cxTranslate }} <i class='material-icons ml-1'>open_in_new</i></a>
        </div>
    </div>
</div>
